import { PseudoElementSelector } from "./pseudo-element.js";
/**
 * {@link https://fullscreen.spec.whatwg.org/#::backdrop-pseudo-element}
 */
export class Backdrop extends PseudoElementSelector {
    static of() {
        return new Backdrop();
    }
    constructor() {
        super("backdrop");
    }
    *[Symbol.iterator]() {
        yield this;
    }
}
(function (Backdrop) {
    Backdrop.parse = PseudoElementSelector.parseNonLegacy("backdrop", Backdrop.of);
})(Backdrop || (Backdrop = {}));
//# sourceMappingURL=backdrop.js.map